/* The corporate-owner business search — its rules.
 *
 * TRANSCRIBED from Details/Search.jsx, Details/AddCompanyName.jsx and the
 * search wiring in OwnershipStructure.jsx.
 */

/* Transcribed: the search only runs from three characters. */
export const MIN_SEARCH_LENGTH = 3;

export const canSearch = (term) =>
  String(term ?? "").trim().length >= MIN_SEARCH_LENGTH;

/* Transcribed: the live parent debounces the term by 400ms before it reaches
   the hook, so typing does not fire a request per keystroke. */
export const SEARCH_DEBOUNCE_MS = 400;

/* Which country every business search in the edit flow starts in. */
export const DEFAULT_SEARCH_COUNTRY = "AE";

/* A result carries `name` on a WorldBox hit and `registered_company_name` on a
   TREVEX one — SearchItem reads both. */
export const resultName = (company) =>
  company?.name || company?.registered_company_name || "";

/* Transcribed from SearchItem: the location line is "State, Country" with the
   state title-cased, and the country resolved from `country_code`. */
export const resultCountryCode = (company) =>
  company?.country_code || company?.country || "";

/* Transcribed from SearchItem's dot: green for verified, blue for claimed,
   otherwise neutral. Named rather than left as three hex literals. */
export const resultState = (company) => {
  if (company?.verifiedCompany) return "verified";
  if (company?.claimed) return "claimed";
  return "listed";
};

/* Which empty state to show. */
export const emptyStateFor = ({ term, results, isLoading, error }) => {
  if (isLoading) return null;
  if (results?.length > 0) return null;

  const typed = String(term ?? "");
  if (typed === "") return "invite";
  if (typed.length >= MIN_SEARCH_LENGTH) {
    return error?.includes?.("WorldboxSearch returned too many hits")
      ? "tooMany"
      : "none";
  }
  return null;
};

export const EMPTY_STATE_TEXT = {
  invite: "Search & Select your business",
  none: "No Results Found",
  tooMany: "Too many results. Please refine your business search.",
};

/* Transcribed: the warning banner shows whenever the hook reports a message,
   and the literal "error" is replaced with a sentence. */
export const searchWarning = (message) => {
  if (!message) return null;
  return message === "error"
    ? "Technical issues may affect results. Please try again later."
    : String(message).trim();
};

/* Transcribed from AddCompanyName's validateErrors, messages included. */
export const validateManualCompany = ({ name, country }) => {
  const errors = {};
  if (String(country ?? "").trim() === "") errors.country = "Country is required.";
  if (String(name ?? "").trim() === "") errors.name = "Business Name is required.";
  return errors;
};

/* Transcribed shape, field for field. */
export const manualCompany = ({ name, country, state }) => ({
  country,
  name,
  state,
});
